var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOperational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 285 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.215 33.72v75.061M212.715 33.72v75.061M212.715 174.219v75.062M72.215 174.219v75.062M108.781 72.212H33.72M249.281 72.212H174.22M249.281 212.712H174.22M108.781 212.712H33.72",
    stroke: "#D6D6D6",
    strokeWidth: 1.813,
    strokeDasharray: "1.92 1.92"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.703,
    cy: 71.703,
    r: 70.703,
    stroke: "#D6D6D6",
    strokeWidth: 1.813,
    strokeDasharray: "1.92 1.92"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.109,
    cy: 71.703,
    r: 70.703,
    stroke: "#D6D6D6",
    strokeWidth: 1.813,
    strokeDasharray: "1.92 1.92"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.109,
    cy: 213.11,
    r: 70.703,
    stroke: "#D6D6D6",
    strokeWidth: 1.813,
    strokeDasharray: "1.92 1.92"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.703,
    cy: 213.11,
    r: 70.703,
    stroke: "#D6D6D6",
    strokeWidth: 1.813,
    strokeDasharray: "1.92 1.92"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.406,
    cy: 142.406,
    r: 70.703,
    stroke: "#F80",
    strokeWidth: 1.813
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.406,
    cy: 142.406,
    r: 70.703,
    stroke: "#F80",
    strokeWidth: 1.813
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.405,
    cy: 142.406,
    r: 29.006,
    stroke: "#F80",
    strokeWidth: 1.813
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 124.178v34.644M158.82 141.5h-34.644",
    stroke: "#F80",
    strokeWidth: 1.813
  })));
}

var MemoSvgOperational = /*#__PURE__*/React.memo(SvgOperational);
export default "data:image/svg+xml;base64,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";
export { MemoSvgOperational as ReactComponent };